import * as rules from "LIB/validation/rules";
import { validator } from "LIB/validate-this";
import { shouldShowWarning } from "MODULES/inventories/components/Detail/Header/DropdownActions/UpdateSrpStatus/Form";
import { EXCHANGE_SRP, SUGGESTED_RETAIL } from "MODULES/inventories/constants";

const meetsMinimumSrp = props => (field, values) => {
  if (props.inventoriesSelected.includes(values.id)) {
    const inventory = props.inventories.filter(i => i.id === values.id)[0];
    if (shouldShowWarning({ inventory, suggestedRetail: field })) {
      return "SRP must be greater than the estimated repair cost";
    }

    return undefined;
  }

  return undefined;
};

function validateItem(item, props) {
  const isSelectedApplyRule = rule => (field, values) => {
    if (props.inventoriesSelected.includes(values.id)) {
      return rule(field);
    }

    return undefined;
  };

  item
    .validate(SUGGESTED_RETAIL)
    .satisfies(isSelectedApplyRule(rules.required), meetsMinimumSrp(props));

  item
    .validate(EXCHANGE_SRP)
    .satisfies(
      isSelectedApplyRule(
        rules.isGreaterThanOrEqualTo(props.minExchangeSrp || 400)
      )
    );
}

export default function(values, props) {
  return validator(values, form => {
    form.validateChildren("inventories", item => validateItem(item, props));
  });
}



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/UpdateSrpStatus/validate.js